export default __webpack_public_path__ + "media/images/svg/ico-psa-annaul-conference-3cac9d7b528cbb4b3d762c0e1b53edf0.svg";